import React from "react";
import { styled } from "styled-components";

import { typeScale } from "lib/themeUtils";

import { BackLink as BackLinkComponent } from "./components/backLink";

export const HeadingEl = styled.header`
  display: grid;
  align-items: center;
  grid-template-rows: min-content;
  grid-template-columns:
    [head-back] min-content
    [head-title] max-content
    [head-meta] max-content
    [head-actions] auto;
`;

const BackLinkWrapper = styled.div`
  grid-column: head-back;
  margin-right: 1rem;
`;

const BackLink: typeof BackLinkComponent = ({ ...props }) => (
  <BackLinkWrapper>
    <BackLinkComponent {...props} />
  </BackLinkWrapper>
);

const Meta = styled.div`
  grid-column-start: head-meta;
  display: flex;
  margin-right: 1rem;
`;
const PageTitle = styled.h1`
  ${typeScale.xxl}
  font-weight: bold;
  grid-column: head-title;
  margin: 0 1rem 0 0;
`;
const SectionTitle = styled.h2`
  ${typeScale.lg}
  font-weight: bold;
  grid-column: head-title;
  margin: 0 1rem 0 0;
`;
const Actions = styled.div`
  grid-column-start: head-actions;
  justify-self: right;
`;

export const Heading: React.FC<React.PropsWithChildren> & {
  Meta: typeof Meta;
  PageTitle: typeof PageTitle;
  SectionTitle: typeof SectionTitle;
  BackLink: typeof BackLink;
  Actions: typeof Actions;
} = ({ children }) => {
  return <HeadingEl>{children}</HeadingEl>;
};

Heading.Meta = Meta;
Heading.PageTitle = PageTitle;
Heading.SectionTitle = SectionTitle;
Heading.BackLink = BackLink;
Heading.Actions = Actions;
